import { ListItemText } from "@mui/material"
import { useStyles } from "./styles"

type Props = {
  name: string
  subtitle?: string
}

const Label: React.FC<Props> = ({ name, subtitle }) => {
  const { classes } = useStyles()

  return (
    <ListItemText
      primary={name}
      secondary={subtitle ? subtitle : ""}
      className={
        subtitle ? classes.menuListItemWithSecondary : classes.menuListItemText
      }
    />
  )
}

export default Label
